<template>
  <div id="parenttem">
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        Balance Report
        <p class="pl-4">|</p>
      </h1>
      <vs-button
        size="small"
        v-if="btndis"
        color="success"
        type="filled"
        icon="add"
        @click="cusAdd"
        >Add</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        size="small"
        color="warning"
        type="filled"
        icon="create"
        @click="cusEdit"
        v-if="btndis"
        >Edit</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        size="small"
        color="danger"
        type="filled"
        icon="remove_circle_outline"
        @click="cusDel"
        v-if="btndis"
        >Delete</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        size="small"
        v-if="btndis3"
        color="#5b3cc4"
        type="filled"
        icon="check_circle_outline"
        @click="ressel"
        >Choose</vs-button
      >
    </div>

    <vx-card class="pb-4">
      <div class="columns">
        <div class="column is-narrow" style="width: 650px">
          <div class="columns">
            <div
              class="column is-narrow mt-3"
              style="width: 150px; text-align: right"
            >
              <span>ผู้ประกอบการ</span>
            </div>
            <div class="column is-narrow">
              <div style="width: 300px">
                <vs-select autocomplete v-model="cmpgroupcode" class="w-full">
                  <vs-select-item
                    v-for="buss in busss"
                    :key="buss.companyGroupsCode"
                    :value="buss.companyGroupsCode"
                    :text="buss.tname"
                  />
                </vs-select>
              </div>
            </div>
<div
              class="column is-narrow mt-3"
              style="width: 200px; text-align: right"
            >
              <span>Outbound Date From</span>
            </div>
            <div
              class="column is-narrow mt-2"
              style="width: 170px; text-align: right"
            >
              <DatePicker
                v-model="fromDate"
                value-type="format"
                format="YYYY-MM-DD"
                :clearable="false"
                class="w-full"
              ></DatePicker>
            </div>
            <div
              class="column is-narrow mt-3"
              style="width: 200px; text-align: right"
            >
              <span>Outbound Date To</span>
            </div>
            <div
              class="column is-narrow mt-2 mr-4"
              style="width: 170px; text-align: right"
            >
              <!-- <datepicker format="yyyy-MM-dd" v-model="todate"></datepicker> -->
              <DatePicker
                v-model="toDate"
                value-type="format"
                format="YYYY-MM-DD"
                :clearable="false"
                class="w-full"
              ></DatePicker>
            </div>
            <div class="column mt-1" style="width: 170px; text-align: right">
              <vs-button
                class="mb-2"
                color="warning"
                icon="search"
                @click="onSubmit"
                >ค้นหา</vs-button
              >
            </div>
            <div v-if="btnshow" class="column mt-1" style="width: 170px">
              <vs-button
                class="mb-2"
                color="#5b3cc4"
                icon="description"
                @click="onReport"
                >Report</vs-button
              >
            </div>
            <div
              v-if="btnshow"
              class="column is-narrow mt-1"
              style="width: 120px"
            >
              <vs-button
                class="mb-2"
                color="success"
                icon="list"
                @click="onExcel"
                >Excel</vs-button
              >
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <transition-group
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <grid
        v-if="gridshow"
        :key="gridshow"
        :fromDate="fromDate"
        :toDate="toDate"
        :companyGroupsCode="cmpgroupcode"
        :businessPartnersCode="businessPartnersCode"
        class="pt-4"
      ></grid>
    </transition-group>

    <b-modal :active.sync="addshow" :width="1024" scroll="keep">
      <banksadd :acstate="acstate" :recid="recid" @grid="grid"></banksadd>
    </b-modal>
  </div>
</template>

<script>
import grid from "./grid";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";
import pdfMake from "pdfmake";
import pdfFonts from "../../../../assets/custom-fonts";
import * as XLSX from "xlsx";

export default {
  props: ["resback"],
  data() {
    return {
      cmpgroupcode: "",
      busss: [],
      businessPartnersCode: "",
      userid: "",
      companyGroupsCode: "",
      btnshow: false,
      btnshow2: false,
      fromDate: "",
      toDate: "",
      title: "",
      btn_list: "",
      btn_choose: "",
      btn_add: "",
      btn_edit: "",
      btn_delete: "",
      ask_delete: "",
      del_complete: "",
      del_error: "",
      addshow: false,
      gridshow: false,
      btndis: false,
      btndis2: true,
      btndis3: true,
      recid: "0",
      curX: null,
      curY: null,
      acstate: null,
    };
  },
  async created() {
    // console.log(this.lang_number);
    // console.log(this.resback);
    try {
      this.busss = [{ companyGroupsCode: "ALL", tname: "ALL" }];

      const formData = {
        searchval: "",
        // inbfrom: this.inbfrom,
      };
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const response3 = await axios.post(
        `${BASE_API_URL}/auth-svc/businesspartners/getBusinessPartnersDTO`,
        formData,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response3.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response3.data.message,
        });
      } else {
       for(let element of response3.data){
        this.busss.push(element)
       }
       
      }
    } catch (error) {
      // throw error;
      alert("กรุณาเข้าระบบอีกครั้ง");
      // this.$router.replace("/pages/login/");
    }
    this.$store.dispatch("setReportGrid", 0);
    // this.gridshow = true;

    this.grid();
    if (typeof this.resback == "undefined") {
      this.btndis2 = true;
      this.btndis3 = false;
    } else {
      this.btndis2 = false;
      this.btndis3 = true;
    }
  },
  watch: {},
  computed: {
    fabStyle: function () {
      return {
        left: this.curX + "px",
        top: this.curY + "px",
      };
    },
  },
  methods: {
    formatnumber(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    onSubmit() {
      if (!this.toDate) {
        // console.log("NOO");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Input Error",
          text: "Please Enter To Date",
        });
      } else {
        // console.log(this.cmpgroupcode)
        this.gridshow = true;
        this.btnshow = true;

        if (this.$store.state.reportgrid == 0) {
          this.$store.dispatch("setReportGrid", 1);
        } else {
          this.$store.dispatch("setReportGrid", 0);
        }
        // console.log(this.toDate);
      }
    },
    // onReport() {
    //   if (!this.toDate) {
    //     // console.log("NOO");
    //     this.$vs.notify({
    //       position: "top-right",
    //       color: "danger",
    //       title: "Input Error",
    //       text: "Please Enter To Date",
    //     });
    //   } else if (!this.fromDate) {
    //     this.$vs.notify({
    //       position: "top-right",
    //       color: "danger",
    //       title: "Input Error",
    //       text: "Please Enter From Date",
    //     });
    //   } else {
    //     this.btnshow = false;
    //     this.btnshow2 = true;

    //     if (this.$store.state.reportgrid == 0) {
    //       this.$store.dispatch("setReportGrid", 1);
    //     } else {
    //       this.$store.dispatch("setReportGrid", 0);
    //     }
    //     // console.log(this.toDate);
    //     let url = localStorage.getItem("appdb");
    //     let dbname = localStorage.getItem("dbname");
    //     let editor = localStorage.getItem("token");

    //     window.open(
    //       url +
    //         "api/ApiReportInbound/" +
    //         this.fromDate +
    //         "/" +
    //         this.toDate +
    //         "/" +
    //         dbname +
    //         "/" +
    //         editor
    //     );
    //   }
    // },
    cvDate(date) {
      let d = new Date(date);
      let dformat =
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
      return dformat;
    },
    cvDateNoTime(date) {
      let d = new Date(date);
      let dformat = [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/");
      return dformat;
    },
    getArray(data) {
      // console.log(data);
      this.arData = [];

      let i = 1;

      data.forEach((item) => {
        // item.updated_at = item.updated_at
        //   ? item.updated_at.replace(/-/g, "/")
        //   : null;
        this.arData.push([
          {
            text: i,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: this.cvDateNoTime(item.dcldate),
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: this.cvDateNoTime(item.ready_at),
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbordersNumber,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.ename,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.mawb,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.hawb,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.clicense,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.cont1,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: this.formatnumber(item.itempck) + " " + item.packagesCode,
            fontSize: 10,
            bold: false,
            alignment: "right",
          },
          {
            text: item.tmotypes_code,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.pol,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.pod,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
        ]);

        i++;
        // console.log(i);
      });
    },
    async onReport() {
      try {
        if (!this.toDate) {
          // console.log("NOO");
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Input Error",
            text: "Please Enter To Date",
          });
        } else {
          const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

          this.loading = true;

          if (token) {
            const formData = {
              companyGroupsCode: this.cmpgroupcode,
              fromDate: this.fromDate,
              toDate: this.toDate,
              // from: '2022-01-11'
            };
            // const response = await axios.post(`${BASE_API_URL}/agents/findall`, formData);

            const response = await axios.post(
              `${BASE_API_URL}/report-svc/reports/balanceReportPrintAll`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );

            // console.log(response.data)

            if (!response.data) {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error",
                text: response.data.message,
              });
            } else {
              // console.log(response.data);

              this.getArray(response.data.inborders);

              const docDefinition = {
                // a string or { width: number, height: number }
                pageSize: "A4",

                // by default we use portrait, you can change it to landscape if you wish
                pageOrientation: "landscape",

                footer: {
                  // columns: [
                  //   "Left part",
                  //   { text: "Right part", alignment: "right" },
                  // ],
                  columns: [
                    [
                      {
                        text: "พิมพ์ ณ วันที่ " + this.cvDate(new Date()),
                        fontSize: 14,
                        alignment: "right",
                        // [left, top, right, bottom]
                        // margin: [100, -20, 0, 0],
                        margin: [0, 0, 10, 0],
                      },
                    ],
                  ],
                },

                content: [
                  {
                    text: "รายงานสินค้าคงเหลือ ณ ศูนย์บริการศุลกากรเพื่อกระจายสินค้า(Balance Cargo)",
                    style: "title",
                    // [left, top, right, bottom]
                    margin: [0, -20, 0, 0],
                  },
                  {
                    text: "จากวันที่ " + this.fromDate + " ถึงวันที่ " + this.toDate,
                    style: "subtitle",
                    margin: [0, 0, 0, 10],
                  },
                  {
                    table: {
                      // headers are automatically repeated if the table spans over multiple pages
                      // you can declare how many rows should be treated as headers
                      headerRows: 1,
                      widths: [25, 55, 55, 50, 80,45,45, 55, 55, 50, 65, 45, 45], // 525(portrait) 700(landscape)
                      body: [
                        [
                          {
                            text: "ลำดับ",
                            bold: true,
                            fontSize: 10,
                            alignment: "center",
                          },
                          {
                            text: "วันที่นำของเข้า Arrival Date",
                            bold: true,
                            fontSize: 10,
                            alignment: "center",
                          },
                          {
                            text: "วันที่นำของเข้าคลัง Inbound Date",
                            bold: true,
                            fontSize: 10,
                            alignment: "center",
                          },
                          {
                            text: "เลขที่เอกสาร",
                            bold: true,
                            fontSize: 10,
                            alignment: "center",
                          },
                          {
                            text: "ชื่อผู้ประกอบกิจการ กระจายสินค้า",
                            bold: true,
                            fontSize: 10,
                            alignment: "center",
                          },
                          {
                            text: "MAWB",
                            bold: true,
                            fontSize: 10,
                            alignment: "center",
                          },
                          {
                            text: "HAWB",
                            bold: true,
                            fontSize: 10,
                            alignment: "center",
                          },
                          {
                            text: "เลขทะเบียนรถยนต์",
                            bold: true,
                            fontSize: 10,
                            alignment: "center",
                          },
                          {
                            text: "หมายเลขตู้ คอนเทนเนอร์",
                            bold: true,
                            fontSize: 10,
                            alignment: "center",
                          },
                          {
                            text: "จำนวนหีบห่อ คงเหลือ / หน่วย",
                            bold: true,
                            fontSize: 10,
                            alignment: "center",
                          },
                          {
                            text: "ประเภทสินค้า (นำเข้า/ ส่งออก/ ผ่านแดน)",
                            bold: true,
                            fontSize: 10,
                            alignment: "center",
                          },
                          {
                            text: "ต้นทาง",
                            bold: true,
                            fontSize: 10,
                            alignment: "center",
                          },
                          {
                            text: "ปลายทาง",
                            bold: true,
                            fontSize: 10,
                            alignment: "center",
                          },
                        ],
                      ],
                    },
                  },
                  {
                    table: {
                      heights: 15,
                      widths: [25, 55, 55, 50, 80,45,45, 55, 55, 50, 65, 45, 45], // 525(portrait) 700(landscape)
                      // body: this.getArray(res.data.message),
                      body: this.arData,
                      // body: [[{}, {}, {}, {}, {},{}, {}, {}]],
                    },
                  },
                ],
                defaultStyle: {
                  // 4. default style 'THSarabunNew' font to test
                  font: "THSarabunNew",
                },
                styles: {
                  title: {
                    fontSize: 18,
                    bold: true,
                    alignment: "center",
                  },
                  subtitle: {
                    fontSize: 16,
                    bold: true,
                    alignment: "center",
                  },
                  header: {
                    fontSize: 18,
                    bold: true,
                    alignment: "right",
                    margin: [0, 190, 0, 80],
                  },
                  subheader: {
                    fontSize: 14,
                  },
                  superMargin: {
                    margin: [20, 0, 40, 0],
                    fontSize: 15,
                  },
                },
              };

              pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
              pdfMake.fonts = {
                // default Roboto font
                Roboto: {
                  normal: "Roboto-Regular.ttf",
                  bold: "Roboto-Medium.ttf",
                  italics: "Roboto-Italic.ttf",
                  bolditalics: "Roboto-MediumItalic.ttf",
                },
                // THSarabunNew Font
                THSarabunNew: {
                  normal: "THSarabunNew.ttf",
                  bold: "THSarabunNew Bold.ttf",
                  italics: "THSarabunNew italic.ttf",
                  bolditalics: "THSarabunNew Bolditalic.ttf",
                },
              };

              setTimeout(() => {
                pdfMake.createPdf(docDefinition).open();
              }, 1000);

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Print Complete",
                text: "Print Complete",
              });
            }
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // await this.$router.replace("/pages/login/");
      }
    },
    async onExcel() {
      if (!this.toDate) {
        // console.log("NOO");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Input Error",
          text: "Please Enter To Date",
        });
      } else {
        try {
          const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
          this.readonly = true;

          if (token) {
            const formData = {
              fromDate: this.fromDate,
              toDate: this.toDate,
              editor: String(this.userid),
              companyGroupsCode: this.cmpgroupcode,
              pol: this.pol,
            };

            const response = await axios.post(
              `${BASE_API_URL}/report-svc/reports/balanceReportPrintAllExcel`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );
            // console.log(response.data);

            if (!response.data) {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response.data.message,
              });
            } else {
              // .xlsx
              let worksheet = XLSX.utils.json_to_sheet(response.data.inborders);
              let workbook = XLSX.utils.book_new();

              XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                "Balance Report"
              );
              XLSX.writeFile(workbook, "Balance_Report.xlsx");

              // .csv
              // let worksheet = XLSX.utils.json_to_sheet(response.data.invoices);
              // let csv = XLSX.utils.sheet_to_csv(worksheet, {FS:'|'});

              // let BOM = "\uFEFF";
              // let csvWithBOM = BOM + csv;
              // let blob = new Blob([csvWithBOM], {type: 'text/csv;charset=utf-8'});
              // // let blob = new Blob([csv], {type: 'text/csv;charset=utf-8'});
              // // fs.writeFileSync("MyCSV.csv",blob);
              // let nowDate = moment().format('YYYYMMDD');
              // // console.log(nowDate)
              // let nowHour = moment().format('HH');
              // // console.log(nowHour)
              // let nowMin = moment().format('mm');
              // // console.log(nowMin)

              // saveAs(blob, 'MTMS_TRANS_'+nowDate+'_'+nowHour+nowMin+'.csv');

              // if (this.$store.state.reportgrid == 0) {
              //   this.$store.dispatch("setReportGrid", 1);
              // } else {
              //   this.$store.dispatch("setReportGrid", 0);
              // }

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Generate Complete",
                text: "Generate Complete",
              });
            }
          }
        } catch (error) {
          this.data = [];
          this.total = 0;
          this.loading = false;
          // throw error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // this.$router.replace("/pages/login/");
        }
      }
    },
    handle_function_call(function_name) {
      this[function_name]();
    },
    ressel() {
      // console.log(this.recid);
      var vm = this;
      vm.$emit("gotres", this.recid);
    },
    // recsel(val) {
    //   // console.log(val);
    //   if (typeof this.resback == "undefined") {
    //     this.btndis = true;
    //     this.btndis3 = false;
    //     this.recid = val;
    //   } else {
    //     this.btndis = false;
    //     this.btndis3 = true;
    //     this.recid = val;
    //   }

    //   // console.log(val[1]);
    // },
    cusAdd() {
      this.recid = 0;
      this.addshow = true;
      this.btndis = false;
      this.acstate = "ADD";
      // this.$store.dispatch("setCompanysTypesGrid", 1);
    },
    grid() {
      this.addshow = false;
      this.btndis = false;
    },
    cusEdit() {
      this.addshow = true;
      this.btndis = false;
      this.acstate = "EDIT";
      // this.$store.dispatch("setCompanysTypesGrid", 1);
    },
    cusDel() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: this.ask_delete + " " + this.recid,
        accept: this.acceptAlert,
      });
    },
    acceptAlert() {
      this.btndis = false;
      const formData = {
        token: localStorage.getItem("token"),
        dbname: localStorage.getItem("dbname"),
        code: this.recid,
      };
      axios
        .post("/ApiDelBanks", formData)
        .then((res) => {
          if (res.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Deleted Error",
              text: this.del_error,
            });
          } else {
            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Deleted Complete",
              text: this.del_complete,
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Deleted Error",
            text: err,
          });
        });

      // this.gridshow = false;
      // this.gridshow = true;
    },
    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    hideFab() {
      this.btndis = false;
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  mounted() {
    this.checkProfiles();
    // console.log(this.$acl.check('admin'));
  },
  components: {
    grid,
    // banksadd
    DatePicker,
  },
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}
.fab {
  background-color: rgb(231, 55, 55);
}
</style>
